import { useEffect, useRef } from 'react';
import { css, cx } from '@linaria/atomic';
import { theme } from '@frontend/theme';
import { CheckIconSmall, MinusIconSmall } from '../../../icon';
import type { BoolInputProps } from '../layouts';
import { BoolInput } from './bool-input.component';
import { CheckboxStyles } from './checkbox.styles';

const stateIconStyle = css`
  transform: scale(0);
  transform-origin: 50% 50%;
  transition: transform 200ms ease-out;
  z-index: ${theme.zIndex.low};
`;

const stateIconActiveStyle = css`
  transform: scale(1);
`;

export const Checkbox = ({
  active,
  error,
  disabled,
  indeterminate = false,
  value,
  tabIndex,
  ...rest
}: BoolInputProps<'checkbox'> & { tabIndex?: number }) => {
  const styles = CheckboxStyles.checkbox({ active, error, disabled, value });
  const fieldRef = useRef<HTMLInputElement>(null);

  const stateIconStyles = cx(stateIconStyle, value && stateIconActiveStyle);

  useEffect(() => {
    // The only way to set a checkbox to indeterminate in HTML and JavaScript is setting the prop in JavaScript
    if (fieldRef.current) {
      fieldRef.current.indeterminate = indeterminate;
    }
  }, [indeterminate]);

  return (
    <div className={styles}>
      {indeterminate ? (
        <MinusIconSmall color='white' className={stateIconStyles} />
      ) : (
        <CheckIconSmall color='white' className={stateIconStyles} />
      )}

      <BoolInput {...rest} type='checkbox' checked={value} disabled={disabled} ref={fieldRef} tabIndex={tabIndex} />
    </div>
  );
};
